const dashboardBaseUrlRaw = import.meta.env.VITE_DASHBOARD_URL || "http://localhost:5173";

export const DASHBOARD_BASE_URL = dashboardBaseUrlRaw.replace(/\/$/, "");
export const DASHBOARD_SIGNIN_URL = `${DASHBOARD_BASE_URL}/signin`;
export const DASHBOARD_SIGNUP_URL = `${DASHBOARD_BASE_URL}/signup`;
